(() => {
  const currencyCode = /\b(?:NIS|ILS)\b/g;
  const moneySelector = [
    '[data-money-format]',
    '[data-zoria-money-format]',
    '[data-zoria-price-template]',
    '.money',
    '.price',
    '.price-item',
    '[id^="price-"]',
    '[id^="Price-"]',
    '.cart-item__totals',
    '.cart-item__details .product-option',
    '.cart-drawer__totals',
    '.cart-drawer__discounts',
    '.cart-drawer__total-savings',
    '.cart__footer',
    '.totals',
    '.sticky-atc',
  ].join(',');

  const formatShekels = (cents) => `${new Intl.NumberFormat(document.documentElement.lang || 'he-IL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cents / 100)} ₪`;

  const updateCartLinePrice = (row, item) => {
    row.querySelectorAll('.cart-item__price-wrapper').forEach((wrapper) => {
      const isUnitPrice = wrapper.dataset.zoriaCartPriceRole === 'unit';
      const originalPriceValue = isUnitPrice ? item.original_price : item.original_line_price;
      const finalPriceValue = isUnitPrice ? item.discounted_price : item.final_line_price;
      if (!Number.isFinite(originalPriceValue) || !Number.isFinite(finalPriceValue)) return;

      let finalPrice = wrapper.querySelector(
        '[data-zoria-cart-current-price], .cart-item__final-price, .regular-price, .price.price--end:not(.cart-item__old-price)',
      );
      if (!finalPrice) return;

      if (finalPriceValue < originalPriceValue) {
        let originalPrice = wrapper.querySelector('.cart-item__old-price');
        if (!originalPrice) {
          originalPrice = document.createElement('s');
          originalPrice.className = 'cart-item__old-price price--end compare-price';
          originalPrice.dataset.zoriaCartOriginalPrice = 'true';
          finalPrice.before(originalPrice);
        }
        originalPrice.textContent = formatShekels(originalPriceValue);
        finalPrice.textContent = formatShekels(finalPriceValue);
        finalPrice.classList.add('cart-item__final-price');
        return;
      }

      wrapper.querySelectorAll('[data-zoria-cart-original-price]').forEach((node) => node.remove());
      finalPrice.textContent = formatShekels(originalPriceValue);
    });
  };

  const replaceText = (node) => {
    if (!node?.nodeValue || node.parentElement?.closest('script, style, template')) return;
    const nextValue = node.nodeValue.replace(currencyCode, '₪');
    if (nextValue !== node.nodeValue) node.nodeValue = nextValue;
  };

  const replaceFormats = (element) => {
    if (!(element instanceof Element)) return;
    ['data-money-format', 'data-zoria-money-format', 'data-zoria-price-template'].forEach((attribute) => {
      const value = element.getAttribute(attribute);
      if (!value) return;
      const nextValue = value.replace(currencyCode, '₪');
      if (nextValue !== value) element.setAttribute(attribute, nextValue);
    });
  };

  const replaceCurrency = (root) => {
    if (root?.nodeType === Node.TEXT_NODE) {
      if (root.parentElement?.closest(moneySelector)) replaceText(root);
      return;
    }
    if (!(root instanceof Element) && !(root instanceof DocumentFragment)) return;

    const containers = [];
    if (root instanceof Element && root.matches(moneySelector)) containers.push(root);
    root.querySelectorAll?.(moneySelector).forEach((element) => containers.push(element));

    containers.forEach((container) => {
      replaceFormats(container);
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      let textNode;
      while ((textNode = walker.nextNode())) replaceText(textNode);
    });
  };

  const start = () => {
    replaceCurrency(document.body);

    let cartSyncTimer = 0;
    let cartSyncVersion = 0;
    const syncCartPrices = async () => {
      const rows = [...document.querySelectorAll('.cart-item')];
      if (!rows.length) return;
      const version = ++cartSyncVersion;
      try {
        const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (version !== cartSyncVersion) return;
        rows.forEach((row) => {
          const index = Number(row.dataset.index || row.id.match(/(\d+)$/)?.[1]) - 1;
          if (cart.items[index]) updateCartLinePrice(row, cart.items[index]);
        });
      } catch (_error) {}
    };
    const scheduleCartPrices = () => {
      window.clearTimeout(cartSyncTimer);
      cartSyncTimer = window.setTimeout(syncCartPrices, 40);
    };
    scheduleCartPrices();

    const queue = new Set();
    let frame = 0;
    const schedule = (node) => {
      if (!node) return;
      queue.add(node);
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        queue.forEach(replaceCurrency);
        queue.clear();
      });
    };

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          if (mutation.target.parentElement?.closest(moneySelector)) schedule(mutation.target);
          return;
        }
        if (mutation.type === 'attributes') {
          schedule(mutation.target);
          return;
        }
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            if (node.parentElement?.closest(moneySelector)) schedule(node);
          } else if (node instanceof Element && (node.matches(moneySelector) || node.querySelector(moneySelector))) {
            schedule(node);
            if (node.matches('.cart-item') || node.querySelector('.cart-item')) scheduleCartPrices();
          }
        });
      });
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['data-money-format', 'data-zoria-money-format', 'data-zoria-price-template'],
      characterData: true,
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
